module.exports = __webpack_public_path__ + "img/operations.6a14c17b.svg";